<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer_top">
        <div class="lianjie">
          友情链接：
          <a
            v-for="item in friendLinks"
            :key="item.text"
            class="footer-link"
            :href="item.href"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ item.text }}
          </a>
        </div>
        <!-- <div class="wang">
          <span
            v-for="(item, idx) in siteLinks"
            :key="item.name"
            class="wang-item"
          >
            <a
              class="footer-link"
              :href="'/category/' + item.id"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.name }}
            </a>
            <span v-if="idx !== siteLinks.length - 1" class="sep"
              >&nbsp;|&nbsp;</span
            >
          </span>
        </div> -->
      </div>
      <div class="footer_bottom">
        <div class="about">
          <span v-for="(item, idx) in siteLinks" :key="item.id">
            <a :href="'/about-us?id=' + item.id" target="_blank" class="menu-item">
              {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </a>
            <span v-if="idx !== siteLinks.length - 1" class="sep">|</span>
          </span>
        </div>
        <div class="beian">
          <!-- {{ footerContent }} -->
                <a :href="'https://beian.miit.gov.cn/'"  style="text-decoration: none;color: inherit;" target="_blank">{{ footerContent }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  props: {
    friendLinks: {
      type: Array,
      default: () => [],
    },
    siteLinks: {
      type: Array,
      default: () => [],
    },
    footerContent: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
.app-footer {
  width: 100%;
  background: #1b1b1b;
  padding: 45px 0 27px 0;
  box-sizing: border-box;
}
.container {
  width: 100%;
  max-width: 76rem;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}
.footer_top {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #dddddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  padding-bottom: 15px;
  box-sizing: border-box;
  .lianjie {
    display: flex;
    margin-bottom: 8px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 20px;
    .footer-link {
      white-space: nowrap;
    }
  }
  .wang {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .wang-item {
      display: inline-flex;
      align-items: center;
    }
    .sep {
      white-space: nowrap;
    }
  }
}
.footer_bottom {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #dddddd;
  display: flex;
  flex-direction: column;
  align-items: center;
  .about {
    margin: 24px 0 15px 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
    .menu-item {
      cursor: pointer;
      text-decoration: none;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #dddddd;
    }
  }
  .beian {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #4c4d4e;
    text-align: center;
    line-height: 1.5;
  }
}

/* 平板端：宽度 <= 1200px 时的布局调整 */
@media (max-width: 1200px) {
  .app-footer {
    padding: 35px 0 20px 0;
  }
  .container {
    padding: 0 20px;
  }
  .footer_top {
    font-size: 14px;
    padding-bottom: 12px;
    .lianjie {
      gap: 15px 25px;
      margin-bottom: 10px;
    }
    .wang {
      gap: 8px;
      font-size: 13px;
      .sep {
        display: none;
      }
    }
  }
  .footer_bottom {
    font-size: 15px;
    .about {
      margin: 20px 0 12px 0;
      gap: 15px;
      font-size: 15px;
      .sep {
        display: none;
      }
    }
    .beian {
      font-size: 14px;
    }
  }
}

/* 移动端：宽度 <= 768px 时的布局调整 */
@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }
  .footer_top {
    font-size: 13px;
    padding-bottom: 15px;
    .lianjie {
      flex-direction: column;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;
      // 确保"友情链接："文本正常显示
      font-size: 13px;
      span {
        margin-right: 0;
        font-size: 13px;
      }
    }
    .wang {
      flex-direction: column;
      gap: 8px;
      align-items: center;
      .sep {
        display: none;
      }
    }
  }
  .footer_bottom {
    font-size: 14px;
    .about {
      gap: 10px;
      margin: 20px 0 15px 0;
      font-size: 0;
      span {
        display: block;
        font-size: 14px;
      }
      .sep {
        display: none;
      }
    }
    .beian {
      font-size: 12px;
      padding: 0 10px;
      word-break: break-all;
    }
  }
}

.footer-link {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}
.footer-link:hover {
  text-decoration: underline;
}
</style>
